import React from 'react'
import { useValue } from '@morningtrain/react-resources'
import { WhenEnvValueMatches } from '@morningtrain/react-helpers'
import * as Displays from '@morningtrain/react-displays'
import { ProductInfo } from 'ui/elements'
import { InventoryItemTotal } from 'support/displays'

export default function InventoryOrderSmartviewItem () {
  const inventoryItemId = useValue('id')

  const totalPath = ['globals.inventory.order_items', inventoryItemId, 'total'].join('.')

  return (
    <WhenEnvValueMatches name={totalPath} matches={v => !!v && v > 0}>
      <ProductInfo
        image={<Displays.Image name='image' className='max-h-full' />}
        title={<Displays.Text name='name' />}
        text={(
          <InventoryItemTotal inventoryItemId={inventoryItemId} />
                         )}
      />
    </WhenEnvValueMatches>
  )
}
